<template>
  <Blog :collection="BlogCollection.PRESS_RELEASES" />
</template>

<script setup lang="ts">
  import { onMounted, useNuxtApp } from '#imports'

  import { BlogCollection } from '~/constants'

  const { $lenisMount } = useNuxtApp()

  onMounted(() => {
    $lenisMount()
  })
</script>
